import * as React from 'react';
import { useLocation } from 'react-router-dom';
import NavMenu from './NavMenu';
import driverinfosecurity from '../../utils/DriverInfoSecurity';
import logger from '../../utils/logger';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

const PAGE_NAMES: [RegExp, string][] = [
    [/^\/$/, 'Home'],
    [/^\/s\/(\d+)$/, 'Site details'],
    [/^\/documents\/\w+/, 'Document viewer'],
    [/^\/documents$/, 'Documents'],
    [/^\/infomessage\/\d+/, 'Info message'],
    [/^\/infomessages$/, 'Info messages'],
    [/^\/administrationsiteinfo/, 'Admin: Site info form'],
    [/^\/administrationsitedetail/, 'Admin: Site detail form'],
    [/^\/administrationdocument\//, 'Admin: Document form'],
    [/^\/administrationdocuments$/, 'Admin: Documents'],
    [/^\/administrationinfomessage\//, 'Admin: News form'],
    [/^\/administrationinfomessages$/, 'Admin: News'],
    [/^\/administrationfeedbackmessages$/, 'Admin: Feedback'],
    [/^\/administrationsites$/, 'Admin: Sites'],
    [/^\/administration$/, 'Admin'],
    [/^\/login$/, 'Login'],
    [/^\/logout$/, 'Logout'],
    [/^\/auth\//, 'Auth'],
];

function getPageName(pathname: string): string {
    for (const [pattern, name] of PAGE_NAMES) {
        if (pattern.test(pathname)) return name;
    }
    return pathname;
}

function getButtonLabel(target: EventTarget | null): string | null {
    if (!(target instanceof Element)) return null;
    const el = target.closest('button, [role="button"]');
    if (!el) return null;
    const ariaLabel = el.getAttribute('aria-label');
    if (ariaLabel) return ariaLabel;
    const text = el.textContent?.replace(/\s+/g, ' ').trim();
    if (text) return text;
    return null;
}

export function Layout({ children }: React.PropsWithChildren<{}>) {
    const location = useLocation();
    const isLoggedIn = driverinfosecurity.hasValidToken();

    React.useEffect(() => {
        logger.info(`Page view: ${getPageName(location.pathname)}`);
    }, [location.pathname]);

    React.useEffect(() => {
        function handleClick(e: MouseEvent) {
            const label = getButtonLabel(e.target);
            if (label) {
                logger.info(`Button click: "${label}" on ${getPageName(location.pathname)}`);
            }
        }
        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, [location.pathname]);
    return (
        <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
            {isLoggedIn ? <NavMenu /> : null}
            {isLoggedIn
                ? <Container maxWidth="xl" sx={{ pt: 2, pb: 4 }}>
                    {children}
                  </Container>
                : children
            }
        </Box>
    );
}
